import type { RevisionPrintParticle } from '../features/review/print/RevisionPrintAction';
import type { TtqSession, TtqSessionParticleEntry } from '../services/ttqService';
import { extractStructuredTextParts } from './textHelper';

function readQuestionMain(entry: TtqSessionParticleEntry): string {
  const fromQuestions = extractStructuredTextParts(entry.particleQuestions).main?.trim();
  if (fromQuestions) return fromQuestions;
  const title = String(entry.particleTitle || '').trim();
  if (title) return title;
  return '未写入题面';
}

export function buildTtqPrintParticles(
  session: TtqSession,
  selectedParticleIds: string[],
): RevisionPrintParticle[] {
  const selected = new Set(selectedParticleIds.map((id) => String(id || '').trim()).filter(Boolean));
  const entries = (session.particles || []).filter((entry) => selected.has(entry.particleId));
  return entries.map((entry) => ({
    id: entry.particleId,
    title: entry.particleTitle,
    questionMain: readQuestionMain(entry),
    subQuestionsExpanded: true,
    subQuestions: extractStructuredTextParts(entry.particleQuestions).items,
  }));
}
